/*
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-23 09:11:03
 */
export default {
  // 在线污染源/餐饮
  cookingFume: {
    url: '/gaochun/airMap/cookingFumeList',
    param: {},
  },
  // 工地
  construction: {
    url: '/gaochun/airMap/constructionList',
    param: {},
  },
  // 企业
  company: {
    url: '/gaochun/airMap/companyList',
    param: {},
  },
  // 汽修
  repair: {
    url: '/gaochun/airMap/otherList',
    param: { type: 2, },
  },
  // 锅炉
  boiler: {
    url: '/gaochun/airMap/otherList',
    param: { type: 4, },
  },
  // 堆场
  yard: {
    url: '/gaochun/airMap/otherList',
    param: { type: 8, },
  },
  // 停车场
  park: {
    url: '/gaochun/airMap/otherList',
    param: { type: 10, },
  },
  // 窑炉
  furnace: {
    url: '/gaochun/airMap/otherList',
    param: { type: 11, },
  },
  // 清单/企业
  companyList: {
    url: '/gaoChunPollute/selectPolluteData',
    param: {
      type: '1',
      pageNum: 1,
      pageSize: 1000,
    },
  },
  // 汽修
  repairList: {
    url: '/gaoChunPollute/selectPolluteData',
    param: {
      type: '2',
      pageNum: 1,
      pageSize: 1000,
    },
  },
  // 餐饮
  cookingFumeList: {
    url: '/gaoChunPollute/selectPolluteData',
    param: {
      type: '3',
      pageNum: 1,
      pageSize: 1000,
    },
  },
  // 锅炉
  boilerList: {
    url: '/gaoChunPollute/selectPolluteData',
    param: {
      type: '4',
      pageNum: 1,
      pageSize: 1000,
    },
  },
  // 工地
  constructionList: {
    url: '/gaoChunPollute/selectPolluteData',
    param: {
      type: '6',
      pageNum: 1,
      pageSize: 1000,
    },
  },
  // 堆场
  yardList: {
    url: '/gaoChunPollute/selectPolluteData',
    param: {
      type: '8',
      pageNum: 1,
      pageSize: 1000,
    },
  },
  // 停车场
  parkList: {
    url: '/gaoChunPollute/selectPolluteData',
    param: {
      type: '10',
      pageNum: 1,
      pageSize: 1000,
    },
  },
  // 窑炉
  furnaceList: {
    url: '/gaoChunPollute/selectPolluteData',
    param: {
      type: '11',
      pageNum: 1,
      pageSize: 1000,
    },
  },
  // 渣土运输停车场
  muckParkList: {
    url: '/gaoChunPollute/selectPolluteData',
    param: {
      type: '12',
      pageNum: 1,
      pageSize: 1000,
    },
  },
  // 加油站
  oilList: {
    url: '/gaoChunPollute/selectPolluteData',
    param: {
      type: '9',
      pageNum: 1,
      pageSize: 1000,
    },
  },
};
